export { default as TableBody } from "./table-body";
